module.exports = __webpack_public_path__ + "static/media/google-map.08d07de3.png";